export const intervalMapping = {
  'year': 'Jährlich',
  'month': 'Monatlich',
  'week': 'Wöchentlich',
  'day': 'Täglich',
}
